/*
 * Module for Notice of Intent to Retire step
 */
rs.module("content/retirementapplication/noticeofintent",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, spcRetirementDate) {
            const purchasingPermissive = $.js(jsSelectors.purchasingPermissive);
            const purchaseDetails = $.js(jsSelectors.purchaseDetails);
            const purchaseInProgressOrCompleted = $.js(jsSelectors.purchaseInProgressOrCompleted);
            const purchaseNotStarted = $.js(jsSelectors.purchaseNotStarted);
            const retirementDate = $.js(jsSelectors.retirementDate);
            const retirementDateHiddenInput = $.js(jsSelectors.retirementDateHiddenInput);

            // Event Listeners
            purchasingPermissive.on('change', function () {
                if ($(this).val() === 'True') {
                    purchaseDetails.show();
                } else {
                    purchaseDetails.hide();
                }
            });

            purchaseInProgressOrCompleted.on('change', function () {
                if ($(this).val() === 'True') {
                    purchaseNotStarted.hide();
                    retirementDate.val(spcRetirementDate);
                    retirementDateHiddenInput.val(spcRetirementDate);
                    retirementDate.setDisabled();
                } else {
                    purchaseNotStarted.show();
                    retirementDate.setDisabled(false);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
